module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.config,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [(_vm.isdecimal) ? _c('el-form-item', {
    attrs: {
      "label": "小数位长度限制"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.config.decimal),
      expression: "config.decimal",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "h-40 w-200",
    attrs: {
      "type": "number",
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.config.decimal)
    },
    on: {
      "blur": [function($event) {
        _vm.setFromMax('decimal')
      }, function($event) {
        _vm.$forceUpdate()
      }],
      "input": function($event) {
        _vm.config.decimal = _vm._n($event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-tips"
  }, [_vm._v("0为输入整数，系统自动补齐两位小数；")])]) : _vm._e(), _vm._v(" "), (!_vm.isdecimal) ? _c('el-form-item', {
    attrs: {
      "label": "最小长度限制",
      "prop": "write_min"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.config.write_min),
      expression: "config.write_min",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "h-40 w-200",
    attrs: {
      "type": "number",
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.config.write_min)
    },
    on: {
      "blur": [function($event) {
        _vm.setFromMax('min')
      }, function($event) {
        _vm.$forceUpdate()
      }],
      "input": function($event) {
        _vm.config.write_min = _vm._n($event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-tips"
  }, [_vm._v("填0代表不限制")])]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "最大长度限制",
      "prop": "write_max"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.config.write_max),
      expression: "config.write_max",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "h-40 w-200",
    attrs: {
      "type": "number",
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.config.write_max)
    },
    on: {
      "blur": [function($event) {
        _vm.setFromMax('max')
      }, function($event) {
        _vm.$forceUpdate()
      }],
      "input": function($event) {
        _vm.config.write_max = _vm._n($event)
      }
    }
  }), _vm._v(" "), (_vm.maxCount != undefined) ? _c('div', {
    staticClass: "form-tips"
  }, [_vm._v("最大长度不能超过" + _vm._s(_vm.maxCount) + "，包括中英文和数字")]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2c06b97c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Model/configComponents/textlenConfig.vue
// module id = 1806
// module chunks = 2